import ViewListaProfili from "../../components/views/profile/oper/listaProfili/ViewListaProfili.jsx";
import ViewProfilForm from "../../components/views/profile/oper/dodajProfil/ViewProfilForm.jsx";
import ViewListaKontProfilu from "../../components/views/profile/oper/listaKontProfilu/ViewListaKontProfilu.jsx";
import ViewListaUzytkownikow from "../../components/views/profile/oper/listaUzytkownikow/ViewListaUzytkownikow.jsx";

export const profileRoutes = [
    {
        path: `/oper/profile/lista`,
        exact: true,
        roles: [`profile_podglad`],
        forbidden: true,
        view: <ViewListaProfili />,
        mode: `any`,
    },
    {
        path: `/oper/profile/uzytkownicy/lista`,
        exact: true,
        roles: [`uzytkownicy_podglad`],
        forbidden: true,
        view: <ViewListaUzytkownikow />,
        mode: `any`,
    },
    {
        path: `/oper/profile/konta/:profilId`,
        exact: true,
        roles: [`profile_podglad`],
        forbidden: true,
        view: <ViewListaKontProfilu />,
        mode: `any`,
    },
    {
        path: `/oper/profile/podglad/:id`,
        exact: true,
        roles: [`profile_podglad`],
        forbidden: true,
        view: <ViewProfilForm />,
        mode: `any`,
    },
    {
        path: `/oper/profile/edycja/:id`,
        exact: true,
        roles: [`profile_modyfikacja`],
        forbidden: true,
        view: <ViewProfilForm />,
        mode: `any`,
    },
]
